import { render, staticRenderFns } from "./FormQuestionCollapse.vue?vue&type=template&id=2ccd0c59"
import script from "./FormQuestionCollapse.vue?vue&type=script&lang=js"
export * from "./FormQuestionCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports